import {z} from 'zod';

/**
 * Sort order for a field.
 */
export enum SortOrder {
	ASCENDING = 'asc',
	DESCENDING = 'desc',
}

/**
 * Sort schema.
 */
export const SortSchema = z.object({
	field: z.string(),
	order: z.nativeEnum(SortOrder),
});
